import { AddVehiclePayload } from '../addVehiclePayload';
import { AddVehicleFormData } from '../addVehicleFormData';
import { workingHoursToPayload } from '@energy-stacks/fleet/feature-vehicles-data';

export const addVehicleDataToPayload = (
  data: AddVehicleFormData,
  coreVehicleId: string
): AddVehiclePayload => {
  return {
    vehicleCoreUuid: coreVehicleId,
    name: data.name,
    depotId: data.plantId.value,
    vehicleIdentificationNumber: data.vehicleId,
    licensePlateNumber: data.licencePlate,
    status: 'AVAILABLE',
    workingHours: {
      ...workingHoursToPayload(data.workingHours),
      // Hardcoded as we don't support it for now, but required on BE
      twentyfourseven: false,
    },
    electricVehicleData: { moSoc: Number(data.moSoc) },
  };
};
